import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('md')]: {
        marginBottom: 56
      },
      '&>:not(:last-child)': {
        marginBottom: 16
      },
      '& .thumbnail': {
        width: 52,
        height: 52,
        border: `1px solid ${colorSet.gray200}`,
        borderRadius: 8,
        '&.avatar': {
          borderRadius: '50%',
          border: 'none'
        }
      },
      '& .no-review': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 422
      }
    },
    item: {
      border: `1px solid ${colorSet.gray400}`,
      borderRadius: 8,
      '&.gutter-bottom': {
        marginBottom: 16,
        [theme.breakpoints.down('md')]: {
          marginBottom: 0,
          borderBottom: `16px solid ${colorSet.gray400}`,
          borderRadius: 0
        }
      },
      '& .project': {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 45,
        marginLeft: 16,
        cursor: 'pointer',
        '& .name': {
          display: 'flex',
          alignItems: 'center',
          '& svg': {
            width: 20,
            height: 20,
            color: colorSet.gray700,
            marginLeft: 2
          },
          '& .chip': {
            display: 'block',
            padding: '1px 6px',
            color: colorSet.primary500,
            backgroundColor: colorSet.primary200,
            border: `1px solid ${colorSet.primary500}`,
            marginRight: 8,
            ...theme.typography.caption
          }
        }
      }
    },
    itemProject: {
      padding: 16,
      display: 'flex',
      alignItems: 'center'
    },
    itemPartner: {
      display: 'flex',
      alignItems: 'center',
      borderTop: `1px solid ${colorSet.gray400}`,
      padding: '26px 16px',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        alignItems: 'flex-start'
      },
      '& .partner': {
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
          marginBottom: 20
        }
      }
    },
    cta: {
      padding: '6px 14px',
      height: 32,
      width: '100%',
      maxWidth: 134,
      marginLeft: 'auto',
      [theme.breakpoints.down('md')]: {
        maxWidth: '100%'
      },
      '& > span': {
        ...theme.typography.body2,
        whiteSpace: 'nowrap'
      }
    },
    visibie: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 24,
      '& button': {
        minWidth: '87px !important'
      }
    }
  }),
  { classNamePrefix: 'review__list' }
);

export default useStyles;
